import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';

import { RegistrationContact } from '../../models/registrationcontact';

/**
 * Generated class for the UpdateRegistrationContactPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-contact',
  templateUrl: 'update-registration-contact.html',
})
export class UpdateRegistrationContactPage {

  private user: any;
  public registrationContact: RegistrationContact;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private validatorProvider: ValidatorProvider
  ) {
    this.registrationContact = new RegistrationContact();

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationContact.email = this.user.email;
      this.registrationContact.phoneMobile = this.user.phoneMobile;
      this.registrationContact.phoneCommercial = this.user.phoneCommercial;
      this.registrationContact.phoneResidential = this.user.phoneResidential;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationContactPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o contato.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationContact.email)) {
      this.alertProvider.doAlert('Forneça seu e-mail.', 'Atenção');
    } else if (!this.validatorProvider.isEmail(this.registrationContact.email)) {
      this.alertProvider.doAlert('Forneça um e-mail válido.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationContact.phoneMobile)) {
      this.alertProvider.doAlert('Forneça seu número de celular.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu contato?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updateContact(that.registrationContact).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seu contato foi salvo com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
            that.user.email = that.registrationContact.email;
            that.user.phoneMobile = that.registrationContact.phoneMobile;
            that.user.phoneCommercial = that.registrationContact.phoneCommercial;
            that.user.phoneResidential = that.registrationContact.phoneResidential;
            that.authProvider.setUser(that.user);

            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar seu contato. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar seu contato. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-contact/update-registration-contact.ts